import { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import { useCommonContext } from "../../../utils/context";

const AssignLeaveModal = ({ show, handleClose, fetchLeaves, isViewMode }) => {
  const [leaveData, setLeaveData] = useState({
    id: null,
    allocated_sick_leave: 0,
    allocated_casual_leave: 0,
    months: 0,
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const { fetchAllusers } = useCommonContext;
  useEffect(() => {
    if (show) {
      fetchExistingLeaveData();
    }
  }, [show]);

  const fetchExistingLeaveData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users/leave-allocations/`, {
        headers: HEADERS,
      });
      if (response.data.results.length > 0) {
        const existingData = response.data.results[0];
        setLeaveData({
          id: existingData.id,
          allocated_sick_leave: existingData.allocated_sick_leave,
          allocated_casual_leave: existingData.allocated_casual_leave,
          months: existingData.months || 0,
        });
        setIsEditMode(true);
      } else {
        setLeaveData({
          id: null,
          allocated_sick_leave: 0,
          allocated_casual_leave: 0,
          months: 0,
        });
        setIsEditMode(false);
      }
    } catch (error) {
      console.error("Failed to fetch existing leave data.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeaveData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const apiURL = `${BASE_URL}/users/leave-allocations/`;
    const payload = {
      allocated_sick_leave: leaveData.allocated_sick_leave,
      allocated_casual_leave: leaveData.allocated_casual_leave,
      months: leaveData.months,
    };

    try {
      const response = await axios.post(apiURL, payload, {
        headers: HEADERS,
      });
      if (response) {
        toast.success("Leaves assigned successfully!");
      }
      fetchLeaves();
      fetchExistingLeaveData()
      fetchAllusers();
      handleClose();
    } catch (error) {
      // toast.error(
      //   error.response?.data?.error ||
      //     "Failed to assign leaves. Please try again."
      // );
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isViewMode
            ? "View Assigned Leaves"
            : isEditMode
            ? "Assigned Leaves"
            : "Assign Leaves"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Row} className="mb-3">
          <Col md={6} className="mb-3 mb-md-0">
            <Form.Label>Sick Leave</Form.Label>
            <Form.Control
              type="number"
              name="allocated_sick_leave"
              value={leaveData.allocated_sick_leave}
              onChange={handleChange}
              placeholder="Enter Sick Leave"
              readOnly={isEditMode || isViewMode}
            />
          </Col>
          <Col md={6}>
            <Form.Label>Casual Leave</Form.Label>
            <Form.Control
              type="number"
              name="allocated_casual_leave"
              value={leaveData.allocated_casual_leave}
              onChange={handleChange}
              placeholder="Enter Casual Leave"
              readOnly={isEditMode || isViewMode}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Col md={12}>
            <Form.Label>Probation Period (In Months)</Form.Label>
            <Form.Control
              type="number"
              name="months"
              value={leaveData.months}
              onChange={handleChange}
              placeholder="Enter"
              readOnly={isEditMode || isViewMode}
            />
          </Col>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {!isViewMode && !isEditMode && (
          <Button onClick={handleSubmit} variant="primary" disabled={loading}>
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Submit"
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default AssignLeaveModal;
